import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { includesAny } from 'app/modules/shared/models/common';
import { rolesFromToken } from 'app/modules/shared/utils/third-party-data';

const ROLES = [
    'ROLE_ADMIN',
    'ROLE_CONTACT',
    'ROLE_JUH_SYSTEM',
    'ROLE_SUPERVISOR',
    'ROLE_USER',
    'ROLE_SSO_ADMIN',
];

export const RoleGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const authService = inject(AuthService);
    // The token comes from the SSO: a token that cannot be read, or a roles claim of the wrong type, gives no roles
    const roles = rolesFromToken(authService.accessToken);
    // if (decode?.auth) {
    //     roles = decode.auth.split(',');
    // }

    const allowedRoles = route.data.roles as Array<string>;

    if (includesAny(roles, allowedRoles)) {
        return true;
    } else {
        // Redirect or handle unauthorized access
        return false;
    }
};
